/* eslint-disable-next no-shadow */
export const CHECKOUT_WIDGET_ID = '14fd5970-8072-c276-1246-058b79e70c1a';

export enum FedopsInteractions {
  ApplyCouponInteraction = 'apply-coupon-interaction',
  RemoveCouponInteraction = 'remove-coupon-interaction',
  ApplyGiftCardInteraction = 'apply-gift-card-interaction',
  RemoveGiftCardInteraction = 'remove-gift-card-interaction',
  PlaceOrderInteraction = 'place-order-interaction',
  ValidatePaymentInteraction = 'validate-payment-interaction',
  InitializePaymentInPlaceOrderInteraction = 'initialize-payment-in-place-order-interaction',
  SubmitCustomerDetailsInteraction = 'submit-customer-details-interaction',
  InitFormsInteraction = 'init-forms-interaction',
  InitFormsController = 'init-forms-controller',
  SetFormsValidator = 'set-forms-validator',
  FillShippingDetailsFormFields = 'fill-shipping-details-form-fields',
  FetchCheckout = 'fetch-checkout',
  SetBillingAndPaymentInteraction = 'set-billing-and-payment-interaction',
  CheckoutPageLoaded = 'checkout-page-loaded',
  SummaryLoaded = 'summary-loaded',
  SetDeliveryMethodInteraction = 'set-delivery-method-interaction',
  SubmitFormInteraction = 'submit-form-interaction',
}

export enum FieldMasks {
  customField = 'customFields',
  extendedFields = 'extendedFields',
  buyerInfoEmail = 'buyerInfo.email',
  shippingContact = 'shippingInfo.shippingDestination.contactDetails',
  shippingAddress = 'shippingInfo.shippingDestination.address',
  shippingAddressesServiceId = 'shippingInfo.shippingDestination.addressesServiceId',
  billingContact = 'billingInfo.contactDetails',
  billingAddress = 'billingInfo.address',
  billingAddressesServiceId = 'billingInfo.addressesServiceId',
  selectedCarrierServiceOption = 'shippingInfo.selectedCarrierServiceOption',
}

export enum AddressesFieldMasks {
  firstName = 'fullName.firstName',
  lastName = 'fullName.lastName',
  company = 'company',
  addressLine1 = 'addressLine1',
  addressLine2 = 'addressLine2',
  city = 'city',
  country = 'country',
  subdivision = 'subdivision',
  zipCode = 'zipCode',
  phoneNumber = 'phoneNumber',
  setAsDefault = 'setAsDefault',
  taxId = 'taxInfo.id',
  taxType = 'taxInfo.type',
  streetName = 'street.name',
  streetNumber = 'street.number',
}

export const FIELDS_GAP = 20;

export const DELIVERY_METHOD_GROUP_NAME = 'deliveryOptions';

export const MAX_CUSTOM_FIELD_VALUE_LENGTH = 250;
export const MAX_ZIP_CODE_FIELD_LENGTH = 250;

export const ONE_COLUMN_VIEW_WIDTH_THRESHOLD = 750;

export const PAYPAL = 'PayPal';

export const FORMS_TEMPLATE_IDS = {
  BILLING: '40f8c94a-07d8-453b-b470-d26508a8da97',
  CUSTOMER_DETAILS: '3f63d41e-9b8e-4631-bfe0-e984965ad618',
};

export const FORMS_CHECKOUT_NAMESPACE = 'wix.ecom.v1.checkout';
export const FORMS_CHECKOUT_DEXT_FQDN = 'wix.ecom.*.checkout';

export const DEFAULT_COUNTRY = 'US';
export const DEFAULT_ITEM_POLICY = 'Item Policy';

export const COUNTRIES_WITH_VAT = ['BR'];

export const COUNTRIES_EXCLUDED_FROM_AUTOCOMPLETE = ['JP'];

export const ADD_NEW_ADDRESS_ID = 'addNewAddress';

export enum THEMES {
  DONATIONS = 'donations',
}

export const DEFAULT_CURRENCY_HEADER = 'DEFAULT';

export const CART_V2_PREFIX = 'ca727402';
